export default "__VITE_ASSET__C5cQXS4M__"